// extracted by mini-css-extract-plugin
export default {"report":"report_report__hzGNT","title":"report_title__8e9Ub"};